<script>
    import { NICHE_TEMPLATES } from '../../data/nicheTemplates.js';
    import Icon from '../icons/Icon.svelte';

    export let selectedNicheId = 'hamburgueria';
    export let storeName = '';
    export let storePhone = '';
    export let onSelectNiche = (nicheId) => {};
    export let onContinue = () => {};
</script>

<div class="niche-selector-flow">
    <!-- CABEÇALHO DA ETAPA 1 -->
    <div class="step-header-text">
        <span class="step-badge">Etapa 1 de 4</span>
        <h2 class="step-title">Qual é o seu negócio?</h2>
        <p class="step-subtitle">Escolha o segmento que mais combina com seu estabelecimento para montarmos a base ideal.</p>
    </div>

    <!-- GRADE DE NICHOS LIMPA COM ÍCONES SVG NATIVOS -->
    <div class="niches-grid">
        {#each NICHE_TEMPLATES as niche}
            <button
                type="button"
                class="niche-card {selectedNicheId === niche.id ? 'is-selected' : ''}"
                on:click={() => onSelectNiche(niche.id)}
            >
                <div class="card-icon-box">
                    <Icon name={niche.svgIcon || 'utensils'} size={22} color={selectedNicheId === niche.id ? '#FF6A00' : '#64748B'} />
                </div>
                <div class="card-content">
                    <span class="niche-name">{niche.name}</span>
                    <span class="niche-desc">{niche.description}</span>
                </div>
                <div class="card-radio">
                    <span class="radio-circle"></span>
                </div>
            </button>
        {/each}
    </div>

    <!-- DADOS ESSENCIAIS (APENAS O BÁSICO) -->
    <div class="essential-store-box">
        <div class="field-item">
            <label for="step1StoreName">Nome do Estabelecimento</label>
            <input
                id="step1StoreName"
                type="text"
                placeholder="Ex: Burger Kingstown, Cantina di Napoli..."
                bind:value={storeName}
                class="clean-input"
            />
        </div>
        <div class="field-item">
            <label for="step1StorePhone">WhatsApp de Atendimento</label>
            <input
                id="step1StorePhone"
                type="text"
                placeholder="Ex: (11) 98765-4321"
                bind:value={storePhone}
                class="clean-input"
            />
        </div>
    </div>

    <!-- AÇÃO PRINCIPAL -->
    <div class="step-footer-action">
        <button
            type="button"
            class="btn-continue"
            on:click={onContinue}
        >
            <span>Continuar</span>
            <Icon name="arrow-right" size={16} color="#FFFFFF" />
        </button>
    </div>
</div>

<style>
    .niche-selector-flow {
        display: flex;
        flex-direction: column;
        gap: 24px;
        max-width: 820px;
        margin: 0 auto;
        width: 100%;
    }

    .step-header-text {
        text-align: left;
    }

    .step-badge {
        display: inline-block;
        font-size: 11px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.8px;
        color: #EA580C;
        background: #FFF7ED;
        padding: 3px 10px;
        border-radius: 6px;
        margin-bottom: 8px;
    }

    .step-title {
        font-size: 24px;
        font-weight: 800;
        color: #0F172A;
        letter-spacing: -0.4px;
        margin: 0 0 6px 0;
    }

    .step-subtitle {
        font-size: 14px;
        color: #64748B;
        margin: 0;
        line-height: 1.5;
    }

    /* GRID LIMPO */
    .niches-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        gap: 12px;
    }

    .niche-card {
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 16px;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        cursor: pointer;
        text-align: left;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }

    .niche-card:hover {
        background: #FAFAFA;
        border-color: #CBD5E1;
        box-shadow: 0 3px 8px rgba(15, 23, 42, 0.06);
    }

    .niche-card.is-selected {
        background: #FFFBF7;
        border-color: #FF6A00;
        box-shadow: 0 0 0 1.5px #FF6A00, 0 3px 8px rgba(255, 106, 0, 0.1);
    }

    .card-icon-box {
        width: 44px;
        height: 44px;
        border-radius: 10px;
        background: #F8FAFC;
        border: 1px solid #E2E8F0;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: all 0.15s ease;
    }

    .niche-card.is-selected .card-icon-box {
        background: #FFF7ED;
        border-color: #FED7AA;
    }

    .card-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 2px;
        overflow: hidden;
    }

    .niche-name {
        font-size: 14px;
        font-weight: 700;
        color: #0F172A;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .niche-card.is-selected .niche-name {
        color: #C2410C;
    }

    .niche-desc {
        font-size: 12px;
        color: #64748B;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .card-radio {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 1.5px solid #CBD5E1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: #FFFFFF;
        transition: all 0.15s ease;
    }

    .niche-card.is-selected .card-radio {
        border-color: #FF6A00;
    }

    .radio-circle {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: transparent;
        transition: background 0.15s;
    }

    .niche-card.is-selected .radio-circle {
        background: #FF6A00;
    }

    /* DADOS DA LOJA */
    .essential-store-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        padding: 20px;
        background: #FFFFFF;
        border: 1px solid #E2E8F0;
        border-radius: 12px;
        box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    }

    .field-item {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .field-item label {
        font-size: 12px;
        font-weight: 600;
        color: #475569;
    }

    .clean-input {
        height: 42px;
        padding: 0 14px;
        border-radius: 8px;
        background: #F8FAFC;
        border: 1px solid #CBD5E1;
        color: #0F172A;
        font-size: 14px;
        outline: none;
        transition: all 0.15s;
    }

    .clean-input:focus {
        background: #FFFFFF;
        border-color: #FF6A00;
        box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.12);
    }

    .clean-input::placeholder {
        color: #94A3B8;
    }

    /* AÇÃO */
    .step-footer-action {
        display: flex;
        justify-content: flex-end;
        padding-top: 8px;
    }

    .btn-continue {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        height: 46px;
        padding: 0 24px;
        background: #FF6A00;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 700;
        border-radius: 10px;
        border: none;
        cursor: pointer;
        transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 6px rgba(255, 106, 0, 0.25);
    }

    .btn-continue:hover {
        background: #EA580C;
        box-shadow: 0 4px 12px rgba(255, 106, 0, 0.35);
        transform: translateY(-1px);
    }

    @media (max-width: 640px) {
        .niches-grid {
            grid-template-columns: 1fr;
        }

        .essential-store-box {
            grid-template-columns: 1fr;
            padding: 16px;
        }

        .btn-continue {
            width: 100%;
            justify-content: center;
        }
    }
</style>
